<template>
  <div class="" v-if="broker != null">
    <div class="text-base text-center">
      Time to set some colours!
    </div>

    <div class="mt-1 text-sm text-gray-700 text-center">
      With a logo and a profile image, your {{ getAppName }} will now start looking like your very own site. 
      Below is a small screenshot of what your site's header will look like.
    </div>

    <div class="mt-3 text-sm text-gray-700 text-center">
      Below you can set the colours of the header's background and the text.
    </div>

    <div class="mt-6 bg-gray-200 px-3 pt-1 pb-4 rounded-lg">
      <div class="">
        <div class="inline-block bg-red-600 w-2 h-2 rounded-full mr-2"></div>
        <div class="inline-block bg-yellow-400 w-2 h-2 rounded-full mr-2"></div>
        <div class="inline-block bg-green-600 w-2 h-2 rounded-full"></div>
      </div>

      <div class="mt-1 flex items-center justify-between p-2" :style="'background-color:' + broker.header_background + ';'">
        <template v-if="broker.logo != null">
          <img :src="broker.logo.url" class="h-16" />
        </template>

        <template v-else>
          <img src="/static/img/brokerpad-logo.png" class="h-16" />
        </template>

        <div class="flex items-center">
          <template v-if="broker.profile_image != null">
            <img :src="broker.profile_image.url" class="w-8 rounded-full" />
          </template>
          <template v-else>
            <img src="https://img.icons8.com/color/48/000000/test-account.png" class="w-8 rounded-full" />
          </template>

          <span class="text-xs ml-2" :style="'color:' + textColor + ';'">
            {{ broker.first_name }} {{ broker.last_name }}
          </span>
        </div>
      </div>
    </div>

    <table class="w-full mt-8 ">
      <tr>
        <td>
          <div class="text-sm text-gray-700 text-center">Header background color</div>

          <div class="mt-2 flex justify-center">
            <sketch-picker v-model="backgroundColor"></sketch-picker>
          </div>
        </td>

        <td class="align-top">
          <div class="text-sm text-gray-700 text-center">Text color</div>

          <div class="mt-2 flex justify-center items-center">
            <input type="radio" name="input-text-color" v-model="broker.header_text" value="0" id="input-text-color-white" />
            <label for="input-text-color-white" class="text-sm ml-2 mr-6">White</label>

            <input type="radio" name="input-text-color" v-model="broker.header_text" value="1" id="input-text-color-black" />
            <label for="input-text-color-black" class="text-sm ml-2">Black</label>
          </div>
        </td>
      </tr>
    </table>

    <div class="text-center mt-20 flex items-center justify-center">
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-green-600 w-3 h-3 rounded-full"></div>
      <div class="inline-block bg-gray-200 w-12 mx-2" style="height:2px;"></div>
      <div class="inline-block bg-gray-400 w-3 h-3 rounded-full"></div>
    </div>

    <div class="mt-4 text-xs">
      <table class="w-full">
        <tr>
          <td class="w-1/3">
            <router-link 
              :to="{
                name  : 'broker-onboard-personalize-two',
                params: {
                  brokerId   : $route.params.brokerId
                }
              }"
              tag="a" 
              class="rounded px-4 py-2 text-xs bg-gray-500 hover:bg-gray-600 text-white float-left">
              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-left"/>
              </svg>
              Back
            </router-link>
          </td>
          <td class="w-1/3">
            <div class="text-gray-600 text-center">Step 3 of 4</div>
          </td>
          <td class="w-1/3">
            <button
              @click.prevent="next()"
              class="rounded px-4 py-2 text-xs float-right bg-blue-500 hover:bg-blue-600 text-white">

              <span class="float-left">Next</span>

              <svg width="16" height="16" stroke-width="2" class="float-left" style="margin-top:1px;" stroke="currentColor" fill="none">
                <use xlink:href="/static/img/feather-sprite.svg#chevron-right"/>
              </svg>
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { Sketch }     from 'vue-color'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2,
      'sketch-picker': Sketch,
    },

    data () {
      return {
        loading: false,
        broker : null,
      }
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
        this.broker.header_text = this.broker.header_text == null ? '0' : this.broker.header_text
      })
    },

    computed : {
      backgroundColor : {
        get() {
          return this.broker.header_background
        },

        set(value) {
          this.broker.header_background = value.hex
        }
      },

      textColor() {
        return this.broker.header_text == 0 ? '#fff' : '#000'
      }
    },

    methods : {
      uploadFile($event, fileType) {
        let file     = $event.target.files[0] || $event.dataTransfer.files[0]
        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', fileType)
        formData.append('brokerId', this.broker.id)
        this.showLoader("Uploading...")

        axios.post(process.env.VUE_APP_API_URL + '/api/broker/upload', formData, {
          headers: {
            'Content-Type'  : 'multipart/form-data',
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
          this.hideLoader()
          this.getCurrentBroker()
        }).catch(function(err) {
          this.hideLoader()
        });
      },

      next() {
        this.apiPost({
          brokerId: this.broker.id,
          values  : {
            header_background: this.broker.header_background,
            header_text      : this.broker.header_text
          }
        }, 'broker/save', () => {
          this.$router.push({
            name  : 'broker-onboard-personalize-four',
            params: {
              brokerId : this.broker.id
            }
          })
        })
      }
    },
  }
</script>